<template>
  <div v-show="isIntroductionModalVisible">
    <div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
        <div class="modal-header">
          <div class="col-11 p-0 float-left text-center">
          <img class="w-60 mt1" src="@/assets/MM-logo.png" alt="MentorMentee" width="100px">
          </div>
          <div class="col-1 p-0 float-left bold" style="text-align: right;">
            <div>
              <button type="button" class="close" data-dismiss="modal" @click="closeModal" style="margin: -15px 0 -15px 0;">&times;</button>
            </div>
            <div style="padding-top: 22px; margin: 0 4px 0 0;" v-if="showSlideNumbers === true">
            {{ parseInt(this.index + 1) }}/{{ this.introductionSlideObj.length }}
            </div>
          </div>
        </div>
        <div class="modal-body" :class="(selectedSlide.showSkipButton === true) ? 'modal-body-h1' : 'modal-body-h2'">
          <div class="col-12 p-0 slide-title">
            {{ selectedSlide.title }}
          </div>
          <!-- Horizontal Items -->
          <div style="margin-bottom: 10px;"></div>
          <div v-if="selectedSlide.template == 1">
          <div class="col-12 p-0" v-for="(item, iindex) in selectedSlide.item" :key="iindex">
            <div v-if="item.type == 'Text'" class="col-12 item-text" >
              <div v-html="item.text"></div>
              <div style="margin-bottom: 10px;"></div>
            </div>
            <div v-if="item.type == 'Image'" class="col-12 text-center" >
              <a :href="item.image_link" target="_blank">
              <img :src="item.image" width="180px" height="100px" />
              </a>
              <div style="margin-bottom: 10px;"></div>
            </div>
            <div v-if="item.type == 'Button'" class="col-12 text-align-right" >
              <button type="submit" class="btn btn-primary btn-md start-button-blue" v-on:click="buttonClick(item.image_link)" style="width: auto !important;">{{ item.text }}</button> 
              <div style="margin-bottom: 10px;"></div>
            </div>
            <div v-if="item.type == 'Link'" class="col-12 text-center" >
              <a :href="item.image_link" target="_blank">
              <div v-html="item.text"></div>
              </a>
              <div style="margin-bottom: 10px;"></div>
            </div>
            <div v-if="item.type == 'Assessment'" class="col-12 p-0 text-center" >
              <div class="col-12 p-0 bold assessment_title">{{ item.assessmentTitle }}</div>
              <div class="col-12 p-0 question_text">
                {{ item.totalQuestions }} Questions
              </div>
              <div style="margin-bottom: 10px;"></div>
              <div class="col-12 p-0 text-center">
                <button type="submit" class="btn btn-primary btn-md start-button-blue" v-on:click="goToAssessmentLanding(item.assessmentId, item.inprogressAttemptId, item.totalQuestions, item.userAssessmentMappingId)">Begin</button> 
              </div>
              <div style="margin-bottom: 10px;"></div>
            </div>
            <div v-if="item.type == 'Course'" class="col-12 p-0 text-center" >
              <div class="col-12 p-0 bold assessment_title">{{ item.text }}</div>
              <div class="col-12 p-0 question_text">
                {{ item.moduleCount }} Modules
              </div>
              <div style="margin-bottom: 10px;"></div>
              <div class="col-12 p-0 text-center">
                <button type="submit" class="btn btn-primary btn-md start-button-blue" v-on:click="goToCourseLanding(item.courseId, item.userCourseMappingId)">Begin</button> 
              </div>
              <div style="margin-bottom: 10px;"></div>
            </div>

          </div>
          </div>

          <div v-if="selectedSlide.template == 2">


            <div>
              
                <div class="col-6 float-left"  >
                <div v-for="(item, iindex) in selectedSlide.item" :key="iindex">
                <div v-if="(iindex == 0 || iindex == 3)">
                  <div v-if="item.type == 'Text'" class="col-12 item-text" >
                    <div v-html="item.text"></div>
                    <div style="margin-bottom: 10px;"></div>
                  </div>
                  <div v-if="item.type == 'Image'" class="col-12 text-center" >
                    <a :href="item.image_link" target="_blank">
                    <img :src="item.image" width="180px" height="100px" />
                    </a>
                    <div style="margin-bottom: 10px;"></div>
                  </div>
                  <div v-if="item.type == 'Link'" class="col-12 text-center" >
                    <a :href="item.image_link" target="_blank" class="link_text">
                    <div v-html="item.text"></div>
                    </a>
                    <div style="margin-bottom: 10px;"></div>
                  </div>
                  <div v-if="item.type == 'Button'" class="col-12 text-left" >
                    <button type="submit" class="btn btn-primary btn-md start-button-blue" v-on:click="buttonClick(item.image_link)" style="width: auto !important;">{{ item.text }}</button> 
                    <div style="margin-bottom: 10px;"></div>
                  </div>
                  <div v-if="item.type == 'Assessment'" class="col-12 text-center" >
                    <div class="col-12 p-0 bold assessment_title">{{ item.assessmentTitle }}</div>
                    <div class="col-12 p-0 question_text">
                      {{ item.totalQuestions }} Questions
                    </div>
                    <div style="margin-bottom: 10px;"></div>
                    <div class="col-12 p-0 text-center">
                      <button type="submit" class="btn btn-primary btn-md start-button-blue" v-on:click="goToAssessmentLanding(item.assessmentId, item.inprogressAttemptId, item.totalQuestions, item.userAssessmentMappingId)">Begin</button> 
                    </div>
                    <div style="margin-bottom: 10px;"></div>
                  </div>
                  <div v-if="item.type == 'Course'" class="col-12 text-center" >
                    <div class="col-12 p-0 bold assessment_title">{{ item.text }}</div>
                    <div class="col-12 p-0 question_text">
                      {{ item.moduleCount }} Modules
                    </div>
                    <div style="margin-bottom: 10px;"></div>
                    <div class="col-12 p-0 text-center">
                      <button type="submit" class="btn btn-primary btn-md start-button-blue" v-on:click="goToCourseLanding(item.courseId, item.userCourseMappingId)">Begin</button> 
                    </div>
                    <div style="margin-bottom: 10px;"></div>
                  </div>
                  </div>
                  </div>
                </div>
                <div class="col-6 float-left"  >
                <div v-for="(item, iindex) in selectedSlide.item" :key="iindex">
                <div v-if="(iindex == 1 || iindex == 2 || iindex == 4)">
                  <div v-if="item.type == 'Text'" class="col-12 item-text" >
                    <div v-html="item.text"></div>
                    <div style="margin-bottom: 10px;"></div>
                  </div>
                  <div v-if="item.type == 'Image'" class="col-12 text-center" >
                    <a :href="item.image_link" target="_blank">
                    <img :src="item.image" width="180px" height="100px" />
                    </a>
                    <div style="margin-bottom: 10px;"></div>
                  </div>
                  <div v-if="item.type == 'Link'" class="col-12 text-center" >
                    <a :href="item.image_link" target="_blank" class="link_text">
                    <div v-html="item.text"></div>
                    </a>
                    <div style="margin-bottom: 10px;"></div>
                  </div>
                  <div v-if="item.type == 'Button'" class="col-12 text-align-right" >
                    <button type="submit" class="btn btn-primary btn-md start-button-blue" v-on:click="buttonClick(item.image_link)" style="width: auto !important;">{{ item.text }}</button> 
                    <div style="margin-bottom: 10px;"></div>
                  </div>
                  <div v-if="item.type == 'Assessment'" class="col-12 text-center" >
                    <div class="col-12 p-0 bold assessment_title">{{ item.assessmentTitle }}</div>
                    <div class="col-12 p-0 question_text">
                      {{ item.totalQuestions }} Questions
                    </div>
                    <div style="margin-bottom: 10px;"></div>
                    <div class="col-12 p-0 text-center">
                      <button type="submit" class="btn btn-primary btn-md start-button-blue" v-on:click="goToAssessmentLanding(item.assessmentId, item.inprogressAttemptId, item.totalQuestions, item.userAssessmentMappingId)">Begin</button> 
                    </div>
                    <div style="margin-bottom: 10px;"></div>
                  </div>
                  <div v-if="item.type == 'Course'" class="col-12 text-center" >
                    <div class="col-12 p-0 bold assessment_title">{{ item.text }}</div>
                    <div class="col-12 p-0 question_text">
                      {{ item.moduleCount }} Modules
                    </div>
                    <div style="margin-bottom: 10px;"></div>
                    <div class="col-12 p-0 text-center">
                      <button type="submit" class="btn btn-primary btn-md start-button-blue" v-on:click="goToCourseLanding(item.courseId, item.userCourseMappingId)">Begin</button> 
                    </div>
                    <div style="margin-bottom: 10px;"></div>
                  </div>
                </div>
                </div>
                </div>
              </div>    







          </div>
          <div style="clear: both"></div>

        </div>
        <div class="modal-footer" v-if="selectedSlide.showSkipButton === true">
          <div class="col-12 p-0" v-if="(this.introductionSlideObj.length != (parseInt(this.index+1)))">
            <div class="col-6 float-left p-0 text-left">
              <button type="submit" class="btn btn-primary btn-md start-button" @click="closeModal()">Skip</button> 
            </div>
            <div class="col-6 float-left p-0 text-align-right">
              <button type="submit" class="btn btn-primary btn-md start-button-blue" @click="getNextPrev()">Next</button> 
            </div>
          </div>
          <div class="col-12 p-0" v-else>
            <div class="col-12 p-0 text-center">
              <button type="submit" class="btn btn-primary btn-md start-button-blue" @click="closeModal()">Close</button> 
            </div>
          </div>          
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import router from '../../router/index.js';

export default {
    props: ['isIntroductionModalVisible', 'introductionId'],
    data() {
        return {
            loading: false,
            selectedSlide: [],
            index: 0,
            lmsUserId: '',
            introductionSlideObj: '',
            showSlideNumbers: '',
        }
    },
    methods: {
        closeModal() {
          this.$emit('close');
        },
        buttonClick: function(link) {
          window.open(link, '_blank');
        },
        getDefaultSlide: function() {
          this.index = 0;
          this.selectedSlide = this.introductionSlideObj[this.index];    
        },
        getNextPrev: function() {
          this.index = parseInt(this.index + 1);
          if(this.index == (this.introductionSlideObj.length)) {
            this.index = parseInt(this.index - 1);
          }
          this.selectedSlide = this.introductionSlideObj[this.index];    
        },
        getIntroduction: function(introductionId) {
          axios.get('/get-dashboard-introduction-slide-preview', {
              params: {
                introductionId: introductionId,
              }
          })
          .then(response =>  {
            this.introductionSlideObj = response.data.introduction_slide;
            this.showSlideNumbers = response.data.showSlideNumbers;
            if(this.introductionSlideObj.length > 0) {
              this.getDefaultSlide();
            }
          })
          .catch(function() {
            
          });

        },
    },
    created() {
      
    },
}
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: hidden;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 780px;
  height: 410px;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 30px;
  overflow-y: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;  
}
.modal-body {
  margin: 0px;
  padding: 0;
  overflow-y: auto;
  
  font-size: 16px;
}
.modal-body-h1 {
  height: 240px;
}
.modal-body-h2 {
  height: 315px;
}
.modal-footer {
  padding: 0px;
  margin: 30px 0;
  text-align: center;
  border: 0;
}
.modal-header {
  padding: 0px;
  border-bottom: 0 none;
  margin-bottom: 10px;
  margin-top: 0px;
  color: #717171;
  font-size: 15px;
}
.modal-header .close {
  padding: 5px;
  font-size: 33px;
}
.slide-title {
  font-size: 18px;
  color: #00ACEE;
  font-weight: bold;
  margin-top: 5px;
}
.item-text, .question_text {
  color: #717171;
  font-size: 17px;
}
.assessment_title {
  color: #717171;
  font-size: 19px;
}
.link_text {
  color: #717171;
  font-weight: bold;
  font-size: 17px;
  text-decoration: underline;
}
.start-button {
  color: #29A3E4 !important;
  background-color: #FFF !important;
  border: 1px solid #29A3E4 !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px 10px 10px 10px;
  line-height: 8px;
  width: 87px;
}
.start-button-blue {
  color: #fff;
  background-color: #29A3E4 !important;
  border: 1px solid #29A3E4 !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px 10px 10px 10px;
  line-height: 8px;
  width: 87px; 
}
</style>
<style >
.item-text p {
  margin-bottom: 5px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/admin/introductionTemplateModalPreview.vue